var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0f8a28bcbf4c6a1f854be7de1479b994.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e8c138cf8399831cd58d9c87ece8a15e.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    